import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionDireccionesAgregarcomponent {
  constructor (FacturacionConfiguracionClientesDirecciones, $state) {
    this.FacturacionConfiguracionClientesDirecciones = FacturacionConfiguracionClientesDirecciones
    this.$state = $state
    this.actualizado = false
    this.clienteId = null
    this.data = null
    this.onAdd = null
    this.onClose = null
  }

  agregar () {
    this.actualizando = true
    return this.FacturacionConfiguracionClientesDirecciones.post(this.clienteId, this.data)
      .then(() => (this.cancelar()))
      .catch((error) => (console.log(error)))
      .finally(() => (this.actualizando = false))
  }

  cancelar () {
    this.$state.go('cliente.informacion.direcciones')
  }

}

module.component('clienteInformacionDireccionesAgregar', {
  controller: ClienteInformacionDireccionesAgregarcomponent,
  template,
  bindings: {
    clienteId: '<',
    onAdd: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/direcciones/agregar/component.js